import { ArrowRight } from "lucide-react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import FadeIn from "../components/FadeIn";
import SEO from "../components/SEO";

const SURVEY_URL = process.env.REACT_APP_SURVEY_URL;

export default function WhatToExpectPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="what-to-expect-page">
      <SEO title="What to Expect" path="/what-to-expect" description="Here's what happens after you join HAEVN — from your first survey to your first match." />
      <Navigation />

      <section className="pt-20 pb-12 md:pt-28 md:pb-16 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <h1 className="font-headline text-4xl sm:text-5xl text-haevn-navy">What to expect</h1>
          </FadeIn>
        </div>
      </section>

      <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      <section className="px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          {[
            { step: "1", text: "You complete your survey", bg: "bg-[#F8F7F5]" },
            { step: "2", text: "You go live your life", bg: "bg-white" },
            { step: "3", text: "Matches appear on Match Monday", bg: "bg-[#F8F7F5]" },
            { step: "4", text: "You decide if you want to connect", bg: "bg-white" },
          ].map((item, i) => (
            <FadeIn key={item.step} delay={i * 100}>
              <div className={`${item.bg} py-14 px-6 md:px-8`}>
                <div className="flex items-start gap-5">
                  <div className="w-10 h-10 rounded-full bg-haevn-teal/10 flex items-center justify-center flex-shrink-0">
                    <span className="font-headline text-haevn-teal">{item.step}</span>
                  </div>
                  <p className="font-subhead text-lg text-haevn-navy pt-2">{item.text}</p>
                </div>
              </div>
            </FadeIn>
          ))}
        </div>
      </section>

      <div className="h-px bg-gradient-to-r from-transparent via-gray-200 to-transparent" />

      <section className="py-16 px-6 md:px-12">
        <div className="max-w-4xl mx-auto">
          <FadeIn>
            <p className="text-xl md:text-2xl text-haevn-navy font-subhead leading-relaxed">
              No pressure. No chasing.
              <br />Just alignment, when it happens.
            </p>
          </FadeIn>
        </div>
      </section>

      <section className="py-20 px-6 md:px-12 bg-haevn-navy">
        <div className="max-w-4xl mx-auto text-center">
          <FadeIn>
            <a href={SURVEY_URL} target="_blank" rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-haevn-gold text-white px-10 py-4 font-subhead text-lg hover:bg-haevn-gold/90 transition-all duration-200 group"
              data-testid="expect-cta-btn">
              Start Your Survey
              <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </a>
          </FadeIn>
        </div>
      </section>

      <Footer />
    </div>
  );
}
